import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=6cfc970e"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/codebuild/output/src1993466134/src/acredo-website/components/Logo.vue').default,Chat: require('/codebuild/output/src1993466134/src/acredo-website/components/Chat.vue').default,AppointmentBubble: require('/codebuild/output/src1993466134/src/acredo-website/components/AppointmentBubble.vue').default,LanguageCheck: require('/codebuild/output/src1993466134/src/acredo-website/components/LanguageCheck.vue').default,Footer: require('/codebuild/output/src1993466134/src/acredo-website/components/Footer.vue').default})
